export default __webpack_public_path__ + "static/media/023-turn-1.31ed8fdc.png";